import { ConnectionAuthConfig } from 'app/connections/types'

import { AuthorizationData } from './AuthorizationButton'

export const getAuthorizationCode = (
  authConfig: ConnectionAuthConfig,
  redirectUri: string,
  handleAuthorizationSuccess: (authorizationData: AuthorizationData<string | undefined>) => unknown,
  handleAuthorizationError: (errorMessage: string | null) => void,
  title: string,
) => {
  const urlString = new URLSearchParams(authConfig.params)
  const url = `${authConfig.url}?redirect_uri=${redirectUri}&${urlString}`

  const authWindow = window.open(
    url,
    `${title} Authorization`,
    `width=500,height=600,left=50,top=50`,
  )

  if (authWindow) {
    const pollTimer = window.setInterval(() => {
      try {
        // Check if the popup is closed without authorization redirect (eg by user)
        if (!authWindow || authWindow.closed) {
          clearInterval(pollTimer) // Stop polling
          return
        }

        const urlParams = new URLSearchParams(authWindow.location.search)
        if (redirectUri.endsWith(authWindow.location.pathname)) {
          if (urlParams.has('code')) {
            window.clearInterval(pollTimer)
            handleAuthorizationSuccess({
              authorizationCode: urlParams.get('code') ?? undefined,
              redirectUri,
            })
            authWindow.close()
          }
          if (urlParams.has('error') || urlParams.has('error_message')) {
            window.clearInterval(pollTimer)
            handleAuthorizationError(urlParams.get('error') ?? urlParams.get('error_message'))
            authWindow.close()
          }
        }
      } catch (_) {
        // ignore as authWindow.location will throw a cors error, until the authorization redirect happend
      }
    }, 500)
  }
}
